import React from 'react';
import { useQuery } from 'react-query';
import { useServiceClient } from 'common';
import { useConfigScopeSelectors } from 'modules/core/scopes';
import { SharedEndPoints, SharedReactQueryKey } from './query-enum';
import { IGetTextData } from './query-interfaces';
import { useDefaultSettingsPayload } from 'modules/default-app-settings/containers';

/**
 * @IAuthenticationSettingsTextData
 * this interface contains types for textdata after parsing it.
 */
export interface IAuthenticationSettingsTextData {
    activeDirectoryConfiguration: { domain: string, audienceURL: string, enableJWT: boolean, isSelected: boolean }
    agilePiontNXConfiguration: { isSelected: boolean }
    googleConfiguration: { clientId: string, returnURL: string, resource: string, isSelected: boolean }
    identityServerConfiguration: { clientId: string, authority: string, isSelected: boolean }
    officeConfiguration: { clientId: string, returnURL: string, resource: string, useMSAuthenticatorApp: boolean, isSelected: boolean }
    officeConfigurationChina: { clientId: string, returnURL: string, resource: string, useMSAuthenticatorApp: boolean, isSelected: boolean }
    oktaConfiguration: { clientId: string, authority: string, isSelected: boolean }
    salesforceConfiguration: { consumerKey: string, consumerSecret: string, isSelected: boolean },
    pingFederateConfiguration: { clientId: string, authority: string, usernameClaimType: string, isSelected: boolean },
    amazonCognitoConfiguration: { clientId: string, authority: string, userImpersonationScopeURL: string, isSelected: boolean },
    serverConfiguration: { developmentServerInstanceUrl?: string, stagingServerInstanceUrl?: string, productionServerInstanceUrl: string }
    defaultConfig: string
}

export const useGetAuthenticationSettingsQuery = () => {
    const { getData } = useServiceClient();
    const currentUserDetails = useConfigScopeSelectors().selectCurrentUserDetails();
    const { getPayloadDetailsByType } = useDefaultSettingsPayload();
    const getAuthenticationSettings = React.useCallback(() => (getData(`${SharedEndPoints.GET_AUTHENTICATION_SETTINGS}${currentUserDetails.userName.replace(/\\/g, '_')}`)
        .then((res) => res.json())
        .catch(() => getPayloadDetailsByType('authentication').authenticationSettings)
    ), [getData, currentUserDetails.userName, getPayloadDetailsByType]);
    return useQuery<IGetTextData>(SharedReactQueryKey.GET_AUTHENTICATION_SETTINGS, getAuthenticationSettings, { retry: 0, cacheTime: 0 });
};
